import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-loading-filled",
  "use": "rt-base-loading-filled-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\" id=\"rt-base-loading-filled\">\n<circle cx=\"50\" cy=\"50\" r=\"42\" stroke=\"#e5f2ff\" stroke-width=\"8\" fill=\"none\"></circle>\n<circle cx=\"50\" cy=\"50\" r=\"42\" stroke=\"#0072e6\" stroke-width=\"8\" stroke-linecap=\"round\" fill=\"none\">\n  <animateTransform attributeName=\"transform\" type=\"rotate\" repeatCount=\"indefinite\" dur=\"2.083333333333333s\" values=\"0 50 50;180 50 50;720 50 50\" keyTimes=\"0;0.5;1\" />\n  <animate attributeName=\"stroke-dasharray\" repeatCount=\"indefinite\" dur=\"2.083333333333333s\" values=\"36.945129606215964 332.5061664559437;184.72564803107986 184.72564803107977;36.945129606215964 332.5061664559437\" keyTimes=\"0;0.5;1\"></animate>\n</circle>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/loading-filled.svg
// module id = 1756
// module chunks = 137